// extracted by mini-css-extract-plugin
export default {"container":"Mpesa_container__X2kqK","body":"Mpesa_body__47ezc","main":"Mpesa_main__jwRzw"};